import { providers } from '../config/environment';

/** Opérateurs connus, par identifiant de fournisseur Netikash (variables REACT_APP_PROVIDER_*). */
const OPERATOR_BY_ID = {
    [providers.RTL]: 'Airtel Money',
    [providers.VOD]: 'M-Pesa',
    [providers.ORG]: 'Orange Money',
    [providers.AFR]: 'Afrimoney',
    [providers.NTK]: 'Netikash Pay',
};

/** Préfixes mobiles RDC (numéro national à 9 chiffres) → opérateur Mobile Money. */
const OPERATOR_BY_PREFIX = [
    [['81', '82', '83'], 'M-Pesa'],
    [['97', '98', '99'], 'Airtel Money'],
    [['80', '84', '85', '89'], 'Orange Money'],
    [['90', '91'], 'Afrimoney'],
];

const isProviderId = (value) => typeof value === 'string' && /^P-\d+-T-PVD$/i.test(value.trim());

/** Opérateur déduit du numéro (ses 9 derniers chiffres). */
export const operatorFromPhone = (phone) => {
    const digits = String(phone || '').replace(/\D/g, '');
    if (digits.length < 9) return null;
    const national = digits.slice(-9);
    const found = OPERATOR_BY_PREFIX.find(([prefixes]) => prefixes.some((p) => national.startsWith(p)));
    return found ? found[1] : null;
};

/** Nom d'opérateur : nom fourni, sinon identifiant du fournisseur, sinon préfixe du numéro. */
export const resolveOperator = ({ name, providerId, phone } = {}) =>
    (name && String(name).trim()) || OPERATOR_BY_ID[providerId] || operatorFromPhone(phone) || null;

/**
 * Moyen de paiement renvoyé par le pos-service. Avant le correctif de PaymentMethodRspDTO,
 * les champs étaient décalés (account = provider_id, expiration_date = numéro, full_name = indicatif) :
 * on reconnaît ce cas pour lire les bonnes valeurs quelle que soit la version déployée.
 */
export const normalizePosMethod = (method) => {
    if (!method) return { providerId: null, providerName: null, prefix: null, account: null };
    if (isProviderId(method.account)) {
        return {
            providerId: method.account,
            providerName: method.suffix || null,
            prefix: method.full_name || null,
            account: method.expiration_date || null,
        };
    }
    return {
        providerId: method.provider_id || null,
        providerName: method.provider_name || null,
        prefix: method.prefix || null,
        account: method.account || null,
    };
};

/** Numéro lisible (+243 812345678) à partir d'un moyen de paiement normalisé. */
export const methodPhone = (m) => (m?.account ? `${m.prefix ? `+${m.prefix} ` : ''}${m.account}` : null);
